/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { Home, Profile } from 'features/components/base';
import { HelpPage, ViewMoreItems, About, SignTermsAndCondtions, AboutUs, Privacy,OurStory } from 'features/components/base/public';

import MyAccountRouter from './MyAccountRouter';
import { EstateSalesRouter } from './EstateSalesRouter';
import { Notifications, Payment } from 'features/components/base/auth-pages';
import { LocationsRouter } from './LocationsRouter';
import { AdvanceSearchRouter } from './AdvanceSearchRouter';
import PaymentAutoDebit from 'features/components/base/auth-pages/payment-page/Payment-auto-debit';
import CategoryPage from 'features/components/base/category-page/CategoryPage';
import PaypalSDK from 'features/components/base/public/paypal-sdk/PaypalSDK';
import { PaymentMethodsAdd } from 'features/components/base/auth-pages/MyAccount';
import VipMembership from 'features/components/base/public/vipmembership/VipMembership';
import { isAuthorized } from 'shared/settings/auth';
import { useSelector } from 'react-redux';
import LogOut from 'features/components/register/LogOut';

/**
 * routing for base components
 * 
 * @param props
 * 
 * @return routing for base components
 * 
**/

const Toggle = (props) => {
    const user = useSelector(state => state.user);

    return isAuthorized() && user.id ? <MyAccountRouter {...props} /> : <LogOut />;
}

export class AppRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/`} component={Home} />
                <Route path={`/advance-search`} component={AdvanceSearchRouter} />
                <Route path={[`/estate-sale`, `/estate-sale-item`]} component={EstateSalesRouter} />
                <Route path={[`/locations`, `/estate-sales`]} component={LocationsRouter} />
                <Route exact path={`/payment`} component={Payment} />
                <Route exact path={`/payment/invoice/:invoiceId`} component={Payment} />
                <Route exact path={`/help/:section`} component={HelpPage} />

                <Route exact path={'/ourstory'} component={OurStory} />
                <Route exact path={'/premier-membership'} component={VipMembership} />
                <Route path={'/my-account'} component={Toggle}></Route>

                <Route path={'/notification'} component={Notifications}></Route>
                <Route exact path={`/profile`} component={Profile} />
                <Route exact path={`/about/:section`} component={About} />
                <Route exact path={`/about`} component={AboutUs} />

                <Route exact path={`/terms`} component={SignTermsAndCondtions} />
                <Route exact path={`/privacy`} component={Privacy} />

                <Route exact path={[`/view-more-items/:type`, `/view-more-items/:saleId/item/:itemId`]} component={ViewMoreItems} ></Route>
                <Route exact path={`/payment-autodebit`} component={PaymentAutoDebit} />
                <Route exact path={[`/paypal-sdk/:buyerId`]} component={PaypalSDK} />
                <Route exact path={`/vault/verification/:paypalkey`} component={PaymentMethodsAdd} />
                <Route exact path={`/vault/cancel`} component={PaymentMethodsAdd} />
                <Route exact path={[`/:categoryname/:subcategoryname`, `/:categoryname`, `/:subcategoryname`]} component={CategoryPage} />
                <Redirect to="/" />
            </Switch >
        );
    }
}
